const APPLICATIONS_CONSTANTS = {
  BANNER: {
    IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/applications-banner.webp`,
    HEADER: ["Use Cases"],
    ALT: "Sisir Radar - Use Cases",
  },
  MAIN: [
    {
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/applications-defence.webp`,
      ALT: "Sisir Radar - Defence use cases",
      TITLE: "DEFENCE",
      BODY: [
        "Battlefield dominance begins with unmatched awareness. Sisir Radar delivers what conventional systems cannot—24/7, all-weather surveillance that detects tunnels, landmines, camouflaged targets and enemy movement with sub-metric precision. Developed under stringent security protocols, every system is battlefield-ready, privacy-assured and built for strategic superiority.",
      ],
      TABS: [
        {
          TITLE: "SAR",
          BODY: ["Offers high resolution, all-weather, real-time intelligence, surveillance and reconnaissance (ISR)."],
          LIST: [
            "X Band– Provides precise mapping and high-quality surveillance.",
            "L Band– Sisir Radar prides itself on developing the world’s highest resolution and the first sub-metric resolution L band SAR. It offers 10x better resolution and superior foliage penetration to detect structures, vehicles, convoys, weapon systems, including artillery hidden beneath dense vegetation.",
            "P Band– The worldʼs first high resolution P band SAR with 10x better resolution provides precise ground penetration to detect tunnels, bunkers and hidden underground structures."
          ],
          IS_LISTED: "SAR",
        },
        {
          TITLE: "GPR",
          BODY: [
            "Detects underground threats such as landmines, IEDs and tunnels, ensuring safe passage for troops and enhancing mission success in challenging terrains.",
          ],
        },
        {
          TITLE: "HYPERSPECTRAL",
          BODY: [
            "Identifies camouflaged targets, analyses terrain features and detects chemical agents, delivering critical insights for strategic planning and tactical advantage.",
          ],
        },
      ],
    },
    {
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/applications-agriculture.webp`,
      ALT: "Sisir Radar - Agriculture use cases",
      TITLE: "AGRICULTURE",
      BODY: [
        "Agriculture faces urgent challenges of erratic weather, soil degradation, water stress and fragmented land use. Sisir Radar provides high resolution, all-weather monitoring to detect crop stress, map irrigation, land use and soil moisture. Our systems ensure precise, scalable insights for timely action and sustainable planning.",
      ],
      TABS: [
        {
          TITLE: "SAR",
          BODY: [
            "Offers all-weather imaging to monitor crops, assess soil fertility, predict yields and evaluate damage for precise insurance payouts, detect soil carbon dioxide (CO₂) and oxygen (O₂) levels to support efficient agricultural planning.",
          ],
        },
        {
          TITLE: "HYPERSPECTRAL",
          BODY: [
            "Analyses soil fertility and crop health, identifies diseases or pest infestations, classifies crop types, monitors growth stages and assesses water stress in plants.",
          ],
        },
      ],
    },
    {
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/applications-mining.webp`,
      ALT: "Sisir Radar - Mining use cases",
      TITLE: "MINING",
      BODY: [
        "Mining operations require strict supervision in locating untapped deposits, curbing illegal operations, managing hazardous terrain and ensuring environmental compliance– all of which demand precision and scale. Sisir Radar delivers deep insight with unmatched reliability. Our systems provide high resolution, all-weather monitoring for tracking excavation activity and revealing unauthorised operations across vast mining regions. Our solutions empower government and private mining enterprises to maximise output while ensuring safety and sustainability.",
      ],
      TABS: [
        {
          TITLE: "SAR",
          BODY: [
            "Aids volume identification for open-cast mining, detects hidden mineral deposits, maps geological hotspots, measures land stability, monitors mining sites and tracks illegal mining, ensuring efficient exploration and reduced environmental impact.",
          ],
        },
        {
          TITLE: "GPR",
          BODY: [
            "Identifies mineral deposits precisely, detects ore bodies, enables targeted exploration and efficient extraction. Detects voids, fractures and unstable formations and assesses caving and flooding risks to ensure safety and effective management.",
          ],
        },
        {
          TITLE: "HYPERSPECTRAL",
          BODY: [
            "Identifies valuable minerals through spectral signatures and detects hazardous chemical and gas leaks to ensure sustainable and efficient resource extraction.",
          ],
        },
      ],
    },
    {
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/applications-urban-planning.webp`,  
      ALT: "Sisir Radar - Urban Planning use cases",
      TITLE: "URBAN PLANNING",
      BODY: [
        "Urban planning is essential for building sustainable, resilient and liveable cities, but rapid urbanisation presents challenges such as ineffective land use management, deteriorating infrastructure and increasing environmental impact. Sisir Radar’s advanced technologies provide precise solutions to these issues, empowering urban planners to design smarter, sustainable cities.",
      ],
      TABS: [
        {
          TITLE: "SAR",
          BODY: [
            "Monitors urban growth, analyses land use patterns, measures land stability and assesses infrastructure conditions, enabling efficient space allocation and proactive development.",
          ],
        },
        {
          TITLE: "GPR",
          BODY: [
            "Monitors construction and assesses structural integrity of pillars, beams, walls, slabs, roads and bridges, identifying cracks and cavities. Locates underground utilities like pipelines, sewers and cables, detecting damage for maintenance.",
          ],
        },
        {
          TITLE: "HYPERSPECTRAL",
          BODY: [
            "Tracks environmental factors, including pollution and vegetation health, providing actionable insights to support sustainable urban development and environmental management.",
          ],
        },
      ],
    },
    {
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/applications-environment.webp`,
      ALT: "Sisir Radar - Environment use cases",
      TITLE: "ENVIRONMENT",
      BODY: [
        "The environment is the foundation of life on Earth, yet it faces growing challenges from climate change, disasters, deforestation, pollution and rapid urbanisation that threaten ecosystems, biodiversity and the sustainability of natural resources. Sisir Radar’s advanced technologies offer precise and scalable solutions, empowering environmental monitoring and restoration efforts.",
      ],
      TABS: [
        {
          TITLE: "SAR",
          BODY: [
            "Monitors deforestation, forest health, glaciers and water bodies for pollution, oil spills and sediment levels. Tracks disasters like floods, landslides and droughts, predicts Glacial Lake Outburst Floods (GLOF) and supports climate analysis.",
          ],
        },
        {
          TITLE: "GPR",
          BODY: [
            "Detects underground features, maps utilities and tracks water conditions without digging. It also identifies cracks and damage for sustainable maintenance and supports archaeology by locating buried structures for accurate digs.",
          ],
        },
        {
          TITLE: "HYPERSPECTRAL",
          BODY: [
            "Monitors vegetation health, identifies biodiversity threats and measures carbon levels— providing critical data to assess and mitigate the impacts of climate change.",
          ],
        },
      ],
    },
  ],
  KNOW_MORE: [
    {
      TITLE: "SYNTHETIC APERTURE RADAR",
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/sar.webp`,
      ALT: "Sisir Radar - Synthetic Aperture Radar",
      LINK: "/technology/sar"
    },
    {
      TITLE: "GROUND PENETRATING RADAR",
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/gpr.webp`,
      ALT: "Sisir Radar - Ground Penetrating Radar",
      LINK: "/technology/gpr"
    },
    {
      TITLE: "HYPERSPECTRAL IMAGING",
      IMG: `${import.meta.env.VITE_IMGIX_SUBDOMAIN}/Applications/hyperspec.webp`,
      ALT: "Sisir Radar - Hyperspectral Imaging",
      LINK: "/technology/hyperspectral"
    },
  ],
};

export default APPLICATIONS_CONSTANTS;
